// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import router from '@/router'
import store from '@/store/index'
import ajax from '@/libs/ajax'
import flexible from './libs/flexible'
import cookie from 'js-cookie'
import { sync } from 'vuex-router-sync'
import Mint from 'mint-ui'

import Vant from 'vant'
import 'vant/lib/index.css'
import '@/assets/css/reset.css'
import '@/assets/css/base.css'
import 'mint-ui/lib/style.css'
// import 'katex/dist/katex.min.css'

import { wxSetTitle } from '@/libs/title'
import { GLOBAL } from '@/store/mutation-type'

import 'babel-polyfill'
Vue.use(ajax)
Vue.use(Mint)
Vue.use(Vant)

/**
 * rem自适应
 */
Vue.use(flexible)

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
        wxSetTitle(to.meta.title)
    }
    next()
})

if (process.env.NODE_ENV !== 'production') {
    // cookie.set('APP', 'MATH_TEACHER')
    // cookie.set('_VERSION', '3.1.1')
    // cookie.set('DEVICE_TYPE', 'IOS')
} else {
    store.dispatch(GLOBAL.ENV)
}

sync(store, router)

/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    router,
    store,
    template: '<router-view></router-view>'
})

// if (cookie.get('APP') === 'MATH_TEACHER') {
//     getUserInfo('/zy/m/t/uc/2/index')
// } else if (cookie.get('APP') === 'MATH_STUDENT') {
//     getUserInfo('/zy/m/s/uc/2/index')
// }

function getUserInfo (url) {
    app.$http.post(url)
        .then((res) => {
            console.log('getUserInfo', url)
            if (res.data.ret_code === 0) {
                app.$store.commit('SET_USUER', res.data.ret)
            }
        })
}



// WEBPACK FOOTER //
// ./src/main.js